module.exports = __webpack_public_path__ + "img/preview-content.7c9b5bff.png";